import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import {UseFormRegisterReturn, ControllerRenderProps} from 'react-hook-form'

interface RenderFieldProps {
    label: string
    registerProps?: UseFormRegisterReturn
    controllerProps?: ControllerRenderProps<any, string>
    error?: string
    type?: string
    placeholder?: string
    disabled?: boolean
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export const RenderField: React.FC<RenderFieldProps> = ({
                                                            label,
                                                            type = 'text',
                                                            placeholder,
                                                            error,
                                                            disabled = false,
                                                            registerProps,
                                                            controllerProps,
                                                            onChange,
                                                        }) => {
    const inputProps = controllerProps
        ? {
              value: controllerProps.value || '',
              onChange: onChange || controllerProps.onChange,
              onBlur: controllerProps.onBlur,
              name: controllerProps.name,
              ref: controllerProps.ref,
          }
        : registerProps || {}

    return (
        <ReactBootstrap.Form.Group className="mt-3 mb-3">
            <ReactBootstrap.Form.Label>
                {label}
                {error ? '*' : ''}
            </ReactBootstrap.Form.Label>

            <input
                className="form-control"
                type={type}
                placeholder={placeholder ?? label}
                disabled={disabled}
                spellCheck
                {...inputProps}
            />

            {error && <span className="text-danger">{error}</span>}
        </ReactBootstrap.Form.Group>
    )
}
